import { useEffect } from 'react';

import { Flex, Button, Paragraph } from '@vimeo/bokeh';
import { InfoCircle } from '@vimeo/bokeh-icons';

import * as finalCopy from '../../../copy/final';

interface Props {
  onLoginRequired: () => void;
}

export const LoginRequiredPanel = ({ onLoginRequired }: Props) => {
  useEffect(() => {
    onLoginRequired();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex h="100%" direction="column" alignItems="center" justifyContent="center" gap="16px">
      <InfoCircle boxSize="md" fill="text-primary" />
      <Paragraph>{finalCopy.youMustBeLoggedIn}</Paragraph>
      <Button onClick={onLoginRequired}>{finalCopy.logIn}</Button>
    </Flex>
  );
};
